import { render, staticRenderFns } from "./SignaturePadTopaz.vue?vue&type=template&id=01a84408&scoped=true"
import script from "./SignaturePadTopaz.vue?vue&type=script&lang=js"
export * from "./SignaturePadTopaz.vue?vue&type=script&lang=js"
import style0 from "./SignaturePadTopaz.vue?vue&type=style&index=0&id=01a84408&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a84408",
  null
  
)

export default component.exports